import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./apiClient";

/**
 * QueryClient da aplicacao.
 *
 * O `retry` e o ponto delicado: repetir automaticamente um 401 ou um 429
 * seria contraproducente. O 401 ja tem o refresh automatico no apiClient
 * (repetir por fora dispararia varios refreshes concorrentes, que a
 * deteccao de reuso do backend interpreta como token roubado), e repetir um
 * 429 e exatamente o que o rate limit esta pedindo para nao fazer.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (error instanceof ApiError) {
            if (error.status === 401 || error.status === 403 || error.status === 404) return false;
            if (error.isRateLimited) return false;
          }
          return failureCount < 2;
        },
      },
      mutations: { retry: false },
    },
  });
}
